import React from "react";

const EServicePage = () => {
    return (
        <div> 
            <p>Page  de presentation des services</p>
        </div>
    );
}

export default EServicePage;